module.exports = __webpack_public_path__ + "static/media/ticket.9df0bc97.jpg";